module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-sm-6 col-lg-3 col-xl-3"
  }, [_c('div', {
    staticClass: "card card-primary"
  }, [_c('div', {
    staticClass: "card-block pb-0"
  }, [_c('div', {
    staticClass: "row flex-nowrap"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('h4', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(_vm.generator_status))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.web_texts.partials.generator_status))])]), _vm._v(" "), _vm._m(0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-6 col-lg-3 col-xl-3"
  }, [_c('div', {
    staticClass: "card card-primary"
  }, [_c('div', {
    staticClass: "card-block pb-0"
  }, [_c('div', {
    staticClass: "row flex-nowrap"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('h4', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(_vm.pot_contracted) + " kW")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.web_texts.partials.pot_contracted))])]), _vm._v(" "), _vm._m(1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-6 col-lg-3 col-xl-3"
  }, [_c('div', {
    staticClass: "card",
    class: _vm.class_card_color
  }, [_c('div', {
    staticClass: "card-block pb-0"
  }, [_c('div', {
    staticClass: "row flex-nowrap"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('h4', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(_vm.api_general) + " kW")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.web_texts.partials.api_general))])]), _vm._v(" "), _vm._m(2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-6 col-lg-3 col-xl-3"
  }, [_c('div', {
    staticClass: "card",
    class: _vm.class_card_color
  }, [_c('div', {
    staticClass: "card-block pb-0"
  }, [_c('div', {
    staticClass: "row flex-nowrap"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('h4', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s(_vm.api_generator) + " kW")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.web_texts.partials.api_generator))])]), _vm._v(" "), _vm._m(3)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-md-6 col-lg-6 col-xl-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('span', [_vm._v(_vm._s(_vm.web_texts.partials.current_tension))])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "text-muted"
  }, [_vm._v("F1-F2")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.v12_generator) + " V")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "text-muted"
  }, [_vm._v("F2-F3")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.v23_generator) + " V")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "text-muted"
  }, [_vm._v("F3-F1")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.v31_generator) + " V")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-6 col-lg-6 col-xl-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('span', [_vm._v(_vm._s(_vm.web_texts.partials.active_power))])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.web_texts.partials.active_power_now))]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.api_generator) + " kW")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-6 col-lg-6 col-xl-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('span', [_vm._v(_vm._s(_vm.web_texts.partials.active_reactive_energy))])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.web_texts.partials.active_power_now))]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.api_generator) + " kW")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-6 col-lg-6 col-xl-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('span', [_vm._v(_vm._s(_vm.web_texts.partials.cos_phi_2))])]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.web_texts.partials.Cos_phi) + " |||")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.cosi_generator) + " φ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-12 col-lg-12 col-xl-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('span', [_vm._v(_vm._s(_vm.web_texts.partials.monthly_active_power))])]), _vm._v(" "), _vm._m(8)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hidden-xs-down col-md-2",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o fa-4x"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hidden-xs-down col-md-2",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-flash fa-4x"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2 hidden-xs-down",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-plug fa-4x card-icon"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2 hidden-xs-down",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-plug fa-4x card-icon"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticStyle: {
      "height": "300px",
      "width": "100%"
    },
    attrs: {
      "id": "tension-generator"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-block"
  }, [_c('canvas', {
    staticStyle: {
      "height": "295px",
      "width": "100%"
    },
    attrs: {
      "id": "active-power-generator"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticStyle: {
      "height": "295px",
      "width": "100%"
    },
    attrs: {
      "id": "active-reactive-energy-generator"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-block"
  }, [_c('canvas', {
    staticStyle: {
      "height": "295px",
      "width": "100%"
    },
    attrs: {
      "id": "cosi-generator"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticStyle: {
      "height": "300px",
      "width": "100%"
    },
    attrs: {
      "id": "pot-act-gen"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2baff069"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/partials/home_partials/GeneratorStatus.vue
// module id = 540
// module chunks = 1